
	import ViewBase from '@/View/Base';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt.kenefick@buck.co>
	 * @package View/Scene/Future
	 * @project buck-impact-2024
	 */
	@Component
	export default class ViewSceneFutureBenefits extends ViewBase {
		// Not implemented
	}
